// En-têtes d'authentification courants, partagés avec le client API sans créer
// de dépendance circulaire avec le store Pinia.
let authHeaders: Record<string, string> = {};

// Mode découverte : quand il est actif, chaque requête porte X-Sandbox afin que
// l'API lise / écrive dans le bac à sable isolé de l'utilisateur (cf. socle
// backend, en-tête reconnu par plugins/auth.ts). Piloté par le store discovery.
let sandboxActive = false;

export function setAuthHeaders(headers: Record<string, string>): void {
  authHeaders = headers;
}

/** Active / coupe le pont bac à sable pour toutes les requêtes API. */
export function setSandboxActive(active: boolean): void {
  sandboxActive = active;
}

export function getAuthHeaders(): Record<string, string> {
  // Les 3 fonctions de lib/api.ts (request/upload/download) étalent ce résultat :
  // ajouter X-Sandbox ici le porte sur toutes, sans les modifier une à une.
  return sandboxActive ? { ...authHeaders, 'X-Sandbox': 'on' } : authHeaders;
}
